//------------------
// get number image
//------------------
const numberImages = import.meta.glob('../assets/images/bbRollNumber*.png', {
  eager: true,
  import: 'default',
})

export default function getNumberImage(number) {
  const key = `../assets/images/bbRollNumber${number}.png`
  return numberImages[key] || null
}
